// SPDX-License-Identifier: BUSL-1.1; Copyright (c) 2025 Social Connect Labs, Inc.; Licensed under BUSL-1.1 (see LICENSE); Apache-2.0 from 2029-06-11

// src/adapters/browser/documents.ts
var DB_NAME = "self-sdk-documents";
var DB_VERSION = 1;
var DOCUMENTS_STORE = "documents";
var CATALOG_STORE = "catalog";
var CATALOG_KEY = "current";
function cloneForStorage(value) {
  if (typeof globalThis.structuredClone === "function") {
    try {
      return globalThis.structuredClone(value);
    } catch {
    }
  }
  return JSON.parse(JSON.stringify(value));
}
function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(DOCUMENTS_STORE)) {
        db.createObjectStore(DOCUMENTS_STORE);
      }
      if (!db.objectStoreNames.contains(CATALOG_STORE)) {
        db.createObjectStore(CATALOG_STORE);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
function txGet(db, store, key) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, "readonly");
    const req = tx.objectStore(store).get(key);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
function txPut(db, store, key, value) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, "readwrite");
    const req = tx.objectStore(store).put(value, key);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}
function txDelete(db, store, key) {
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, "readwrite");
    const req = tx.objectStore(store).delete(key);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  });
}
function createIndexedDBDocumentsAdapter() {
  let dbPromise = null;
  function getDB() {
    if (!dbPromise) {
      dbPromise = openDB();
    }
    return dbPromise;
  }
  return {
    async loadDocumentCatalog() {
      const db = await getDB();
      const catalog = await txGet(db, CATALOG_STORE, CATALOG_KEY);
      return catalog ?? { documents: [] };
    },
    async saveDocumentCatalog(catalog) {
      const db = await getDB();
      await txPut(db, CATALOG_STORE, CATALOG_KEY, cloneForStorage(catalog));
    },
    async loadDocumentById(id) {
      const db = await getDB();
      const doc = await txGet(db, DOCUMENTS_STORE, id);
      return doc ?? null;
    },
    async saveDocument(id, passportData) {
      const db = await getDB();
      await txPut(db, DOCUMENTS_STORE, id, cloneForStorage(passportData));
    },
    async deleteDocument(id) {
      const db = await getDB();
      await txDelete(db, DOCUMENTS_STORE, id);
    }
  };
}

export {
  cloneForStorage,
  createIndexedDBDocumentsAdapter
};
//# sourceMappingURL=chunk-7LIQMR7P.js.map